module.exports = __webpack_public_path__ + "static/media/AvertaStd-Semibold.9ee0216e.ttf";